import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddSalesItem = createAsyncThunk(
  "/fetchAsyncAddSalesItem",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/sales-item/create`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncUpdateSalesItem = createAsyncThunk(
  "/fetchAsyncUpdateSalesItem",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/sales-item/update/${data?.id}`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetSalesItem = createAsyncThunk(
  "/fetchAsyncGetSalesItem",
  async () => {
    try {
      let url = `${API_URL}/sales-item/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetSalesItemById = async (id) => {
  try {
    let url = `${API_URL}/sales-item/get/${id}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
}

export const fetchAsyncDeleteSalesItem = createAsyncThunk(
  "/fetchAsyncDeleteSalesItem",
  async (id) => {
    try {
      let url = `${API_URL}/sales-item/delete/${id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const fetchAsyncSearchSalesItemsData = createAsyncThunk(
  "/fetchAsyncSearchSalesItemsData",
  async (data) => {
    try {
      let url = `${API_URL}/sales-item/search`;
      const params = new URLSearchParams();
      if (data.value) params.append('search', data.value);
      if (data.currency) params.append('currency', data.currency);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncGetSalesItemByClient = createAsyncThunk(
  "/fetchAsyncGetSalesItem",
  async (data) => {
    try {
      let url = `${API_URL}/sales-item/get-by-client/${data?.clientId}/${data?.currency}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
const AllSalesItemSlice = createSlice({
  name: "salesItemData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetSalesItem.pending]: (state) => {},
    [fetchAsyncGetSalesItem.fulfilled]: (state, { payload }) => {
      return payload;
    },
    [fetchAsyncSearchSalesItemsData.pending]: (state) => {},
      [fetchAsyncSearchSalesItemsData.fulfilled]: (state, { payload }) => {
        return payload.items;
      },
   
  },
});


export const getAllSalesItem = (state) => state.salesItemData;

export default AllSalesItemSlice.reducer;




